import type {
  BuilderBlock,
  BuilderContextInterface,
  RegisteredComponent,
  RegisteredComponents,
} from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

const rowInputs = [] as const satisfies Inputs;

export type RowProps = BuilderComponentProps<typeof rowInputs> & {
  builderBlock: BuilderBlock;
  builderContext: BuilderContextInterface;
  builderComponents: RegisteredComponents;
  attributes: Record<string, string>;
};

export const RowComponent: RegisteredComponent = {
  name: "Row",
  component: dynamic(() => import("./Row").then((mod) => mod.Row)),
  inputs: rowInputs,
  canHaveChildren: true,
  noWrap: true,
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderComponents: true,
    builderContext: true,
  },
  childRequirements: {
    message: "Children of 'Row' must be 'Column'",
    query: {
      "component.name": {
        $in: ["Column"],
      },
    },
  },
  defaultChildren: [
    {
      "@type": "@builder.io/sdk:Element",
      component: {
        name: "Column",
        options: {
          desktopWidth: "6",
        },
      },
    },
    {
      "@type": "@builder.io/sdk:Element",
      component: {
        name: "Column",
        options: {
          desktopWidth: "6",
        },
      },
    },
  ],
};
